import script from "./ComHuonekorttiInfoDropDownButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiInfoDropDownButton.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiInfoDropDownButton.vue?vue&type=style&index=0&id=6afb2d5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afb2d5e"]])

export default __exports__